export class KafkaSampleProbeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "messages",
            "baseName": "messages",
            "type": "Array<KafkaMessageSample>",
            "format": ""
        },
        {
            "name": "detectedFormat",
            "baseName": "detectedFormat",
            "type": "DetectedFormat",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSampleProbeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
